/** Refresh visible forecasts on resume and reconnection. */
export function startForecastRefresh({ refresh, isLoading }, windowTarget = window, documentTarget = document) {
    const refreshIfVisible = () => {
        if (documentTarget.visibilityState === 'visible' && !isLoading()) {
            refresh();
        }
    };

    const handlePageShow = (event) => {
        // Initial navigation already loads through the route watcher.
        if (event.persisted) refreshIfVisible();
    };

    documentTarget.addEventListener('visibilitychange', refreshIfVisible);
    windowTarget.addEventListener('online', refreshIfVisible);
    windowTarget.addEventListener('pageshow', handlePageShow);

    return () => {
        documentTarget.removeEventListener('visibilitychange', refreshIfVisible);
        windowTarget.removeEventListener('online', refreshIfVisible);
        windowTarget.removeEventListener('pageshow', handlePageShow);
    };
}
